import { useI18nContext } from "@hopper-b2b/i18n";
import { useModuleBEM, useUiStyles } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import defaultStyles from "./ListError.module.scss";
import clsx from "clsx";
import { PropsWithChildren } from "react";

export type ListErrorProps = PropsWithChildren<{
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onTapReload: () => void;
  className?: string;
}>;

export const ListError = ({
  className,
  title,
  subtitle,
  buttonText,
  onTapReload,
  children,
}: ListErrorProps) => {
  const COMPONENT_KEY = CoreUiComponents.ListError;
  const styles = useUiStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  const titleCopy = title || t("genericShopErrorTitle");
  const subtitleCopy = subtitle || t("genericShopErrorSubtitle");
  const buttonCopy = buttonText || t("genericShopErrorButton");
  return (
    <div className={clsx(block, className)}>
      <div className={cn("title")}>{titleCopy}</div>
      <div className={cn("subtitle")}>{subtitleCopy}</div>
      <button onClick={onTapReload} className={cn("button")}>
        {buttonCopy}
      </button>
      {children}
    </div>
  );
};
